export default "__VITE_ASSET__P0WwKYC7__"